import type {ReactElement} from 'react';
import {useContext} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {getPmwLogoUrl} from '@Utils/logo.util';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {EditorViewport} from '@FormMakerReact/form-maker.types';
import {navigateBackFromSignupFormEditor} from '@FormMakerReact/lib/form-maker-access-library';
import styles from '@FormMakerReact/layout/form-maker-header/form-maker-header.module.scss';

export function LogoLink(): ReactElement {
  const {state, store} = useContext(formMakerContext);
  const isCompact = state.editorViewport !== EditorViewport.DESKTOP;
  const className = isCompact ? `${styles.logoLink} ${styles.logoLinkCompact}` : styles.logoLink;

  const goBack = (): void => {
    navigateBackFromSignupFormEditor(store);
  };

  return (
    <ClickableDiv className={className} onClick={goBack} aria-label={window.i18next.t('pmwjs_form_maker_back_to_dashboard')}>
      <img className={styles.logoImg} src={getPmwLogoUrl(!isCompact)} alt="PosterMyWall" />
    </ClickableDiv>
  );
}
